export const getRasipalanPath = () => "horoscope/rasipalan";
